// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2-adW","approved":"Status_approved__3JjVw","rejected":"Status_rejected__3w9IQ","expired":"Status_expired__1MeTr","label":"Status_label__2qIdy"};